import React from "react";
import BottomSheet from "../../BottomSheet";

import BluetoothSettingsAndroidImg from "src/assets/images/common/bluetooth-settings-android.png";
import BluetoothSettingsIosImg from "src/assets/images/common/bluetooth-settings-ios.png";

import storage from "src/helpers/storage";
import { POST_MESSAGE_EVENTS, STORAGE_KEYS } from "src/constants/common";
import Button from "../../Button";
import { Settings } from "@material-symbols-svg/react";
import sendMessageToParent from "src/helpers/parentMessageHandler";

interface Props {
  show: boolean;
  handleClose: () => void;
}

const BluetoothConnectionBottomSheet: React.FC<Props> = ({
  show,
  handleClose,
}) => {
  const platform = storage.getItem(STORAGE_KEYS.PLATFORM) ?? "android";

  const openSettings = () => {
    sendMessageToParent(POST_MESSAGE_EVENTS.OPEN_SETTINGS, {
      permission: "bluetooth",
    });
  };

  return (
    <BottomSheet
      title="Bluetooth Connection"
      show={show}
      showCloseButton={true}
      handleClose={handleClose}
    >
      <div className="flex flex-col items-center justify-center gap-4 p-4">
        <p className="text-sm text-gray-700 text-left">
          {platform === "android"
            ? `If bluetooth permission is turned off. To continue syncing your CGM,
          please enable Bluetooth access for GoodFlip Care in your phone Settings`
            : `GoodFlip Care needs Bluetooth access to sync your CGM data. Please allow Bluetooth access to continue connecting your device.`}
        </p>
        <img
          src={
            platform === "android"
              ? BluetoothSettingsAndroidImg
              : BluetoothSettingsIosImg
          }
          className="w-full h-auto bg-gray-100 rounded-lg p-4 object-contain"
        />

        <Button variant="text" onClick={() => openSettings()}>
          <p className="flex items-center gap-2">
            <Settings className="w-5 h-5" />
            <span className="underline">Open Settings</span>
          </p>
        </Button>
      </div>
    </BottomSheet>
  );
};

export default BluetoothConnectionBottomSheet;
